export default __webpack_public_path__ + "static/media/grass_field.a618bc20.jpg";